import { useMutation, useQueryClient } from '@tanstack/react-query';

import { invalidateClinicalBundle } from '../lib/invalidateSessionCaches';
import { sessionsService, type NoteWriteInput } from '../services';

import { sessionsKeys } from './useSessions';

export function useCreateSessionNote(sessionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: NoteWriteInput) => sessionsService.createNote(sessionId, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note', sessionId) });
      void qc.invalidateQueries({ queryKey: sessionsKeys.operation('note-meta', sessionId) });
      // The drawer renders from the clinical bundle, not the `note` key — refresh
      // it so a freshly created note appears without a manual page reload.
      invalidateClinicalBundle(qc, sessionId);
    },
  });
}
